import React, { useState } from "react";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";

import { useTranslation } from "react-i18next";
import i18next from "i18next";

import defaultProfileImage from "assets/img/convention/collageTest.jpg";
import { makeStyles } from "@material-ui/core";

import style from "./TestimonialInfoMobileStyle";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";

const useStyles = makeStyles( style, {...styles} );

export default function TestimonialInfoMobile({ testimonial }) {
  const classes = useStyles();
  const { t } = useTranslation(["common"]);
  const getCurrentLng = () =>
    i18next.language || window.localStorage.i18nextLng || "en";
  const selectedLanguage = getCurrentLng();

  const { name, description, url, img } = testimonial;

  const [showMore, setShowMore] = useState(false);
  const toggleShowMore = () => setShowMore(!showMore);

  const text = description[selectedLanguage] || "";
  const truncatedDescription = showMore ? text : `${text.slice(0, 150)}...`;

  return (
    <Card className={classes.card}>
      <CardBody className={classes.cardBody}>
        <h4 className={classes.cardTitle}>
          {truncatedDescription}
        </h4>
        {text.length > 100 && (
          <p
            className={classes.showMoreOrLess}
            onClick={toggleShowMore}
          >
            {showMore ? t("readLess") : t("readMore")}
          </p>
        )}
      </CardBody>
      <CardFooter className={classes.cardFooter}>
        <div className={classes.author}>
          <a
            {...(url ? { href: url } : {})}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "flex", alignItems: "center", gap: "10px" }}
          >
            <img
              src={img || defaultProfileImage}
              alt={name}
              className={classes.img}
            />
            <span className={classes.authorText}>{name}</span>
          </a>
        </div>
      </CardFooter>
    </Card>
  );
}